// Neos standalone workspace previews inherit the user's editing mode too.
// Keep its grid inside the editor iframe, but animate when opened as a page.
if (window.self === window.top) {
	const animateSliders = () => {
		document.querySelectorAll('.logo-slider').forEach(slider => {
			slider.setAttribute('data-animate', '');
		});
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', animateSliders);
	} else {
		animateSliders();
	}
}
